<template>
  <v-simple-table class="elevation-0 mb-4">
    <template v-slot:default>
      <thead>
        <tr>
          <th>Nº</th>
          <th>SERVIDOR</th>
          <th class="text-center">{{ `${itemA.letra}. ${itemA.descricao}`.toUpperCase() }}</th>
          <th class="text-center">{{ `${itemB.letra}. ${itemB.descricao}`.toUpperCase() }}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(resposta, index) in respostas"
          :key="resposta.id"
        >
          <td>
            <span class="grey--text text--darken-2">{{ ++index }}</span>
          </td>
          <td>
            <span class="grey--text text--darken-2">{{ resposta.servidor }}</span>
          </td>
          <td class="text-center">
            <v-icon color="grey">
              {{ getCheckBoxIcon(resposta.itemEscolhido, itemA) }}
            </v-icon>
          </td>
          <td class="text-center">
            <v-icon color="grey">
              {{ getCheckBoxIcon(resposta.itemEscolhido, itemB) }}
            </v-icon>
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
export default {
  name: 'ExpansaoResultadoUnidadePreferencia',

  props: {
    itemA: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    itemB: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    respostas: {
      type: Array,
      required: true,
      default: () => [],
    },
  },

  methods: {
    getCheckBoxIcon(itemEscolhido, item) {
      if (itemEscolhido && itemEscolhido.id === item.id) {
        return 'check_box';
      }
      return 'check_box_outline_blank';
    },
  },
};
</script>
